module.exports = __webpack_public_path__ + "static/img/illustrator2@2x.f44fc07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/illustrator2@2x.png
// module id = arf/
// module chunks = 1